'use client';

import { useTranslations } from 'next-intl';
import CWButton from '@/context/global/components/g00/g00-d00-g006-cw-button';
import PeopleDanceMusicSVG from '@/context/global/assets/PeopleDanceMusic';

export interface ErrorNoPackageProps {
  message?: string;
  trySongButtonText?: string;
  buyPackageButtonText?: string;
  onClickTrySong?: () => void;
  onClickBuyPackage?: () => void;
}

const ErrorNoPackage = ({
  message,
  trySongButtonText,
  buyPackageButtonText,
  onClickTrySong,
  onClickBuyPackage,
}: ErrorNoPackageProps) => {
  const t = useTranslations('KaraokeError');

  const displayMessage = message ?? t('noPackageLine1');
  const displayTrySongText = trySongButtonText ?? t('trySong');
  const displayBuyPackageText = buyPackageButtonText ?? t('buyPackage');

  return (
    <div className="bg-background mt-10 flex min-h-screen w-full items-start justify-center px-4 md:mt-0 md:items-center">
      <div className="flex w-full max-w-[500px] flex-col items-center gap-6 sm:gap-8 md:gap-10 lg:gap-12">
        {/* Illustration and Text */}
        <div className="flex w-full flex-col items-center gap-3 sm:gap-4 md:gap-5">
          {/* Illustration */}
          <PeopleDanceMusicSVG className="h-auto w-[160px] sm:w-[200px] md:w-[240px] lg:w-[280px]" />

          {/* Text Content */}
          <div className="flex w-full flex-col items-center text-center text-white">
            <p className="text-[16px] font-bold leading-[22px] sm:text-[20px] sm:leading-[26px] md:text-[24px] md:leading-[30px] lg:text-[28px] lg:leading-[34px]">
              {displayMessage}
            </p>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex w-full flex-row justify-center gap-3 sm:gap-4 md:gap-5">
          <CWButton
            title={displayTrySongText}
            variant="white"
            outline
            className="h-[44px] w-[140px] rounded-lg text-[16px] font-bold sm:h-[48px] sm:w-[160px] sm:text-[18px] md:h-[52px] md:w-[180px] md:text-[22px] lg:h-[56px] lg:w-[200px] lg:text-[26px]"
            onClick={onClickTrySong}
          />
          <CWButton
            title={displayBuyPackageText}
            variant="white"
            className="h-[44px] w-[140px] rounded-lg text-[16px] font-bold sm:h-[48px] sm:w-[160px] sm:text-[18px] md:h-[52px] md:w-[180px] md:text-[22px] lg:h-[56px] lg:w-[200px] lg:text-[26px]"
            onClick={onClickBuyPackage}
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorNoPackage;
